import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const OPEN_AUCTION = 'AUCTION :: OPEN_AUCTION';

export type TOpenAuctionAction = IReduxAction<typeof OPEN_AUCTION>;

export const openAuction = actionGenerator<typeof OPEN_AUCTION>(OPEN_AUCTION);
